import { Layout } from '@eneco/flows/components';
import { createFlowProvider } from '@eneco/flows/utils';

import { routes, actions, initialContext } from './B2BLeadFlow.config';
import { Navigation } from './components/Navigation/Navigation';
import { B2BLeadFlowContext } from './types';

const { Provider, Router } = createFlowProvider<B2BLeadFlowContext>({
  routes,
  actions,
  initialContext,
  stickyQueryParams: ['product'],
});

const B2BLeadFlow = () => {
  return (
    <Provider>
      <Layout>
        <Layout.Header>
          <Navigation routes={routes} />
        </Layout.Header>
        <Router />
      </Layout>
    </Provider>
  );
};

export default B2BLeadFlow;
